import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { Router } from '@angular/router';
import { CKEDITORCONFIG } from '../ckeditor-config';
import { BookingReportTemplate } from '../booking-report-template';
import { PrimeToastService } from '../prime-toast.service';
import { PdfDocumentType } from '../pdf-document-type';
import { Language } from '../language';
import { PdfDocumentCategory } from '../pdf-document-category';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { SelectItem } from 'primeng/api';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-pdf-template-create',
  templateUrl: './pdf-template-create.component.html',
  styleUrls: ['./pdf-template-create.component.css']
})
export class PdfTemplateCreateComponent implements OnInit {

  templateForm!: FormGroup;
  languages: Language[] = [];
  advancedEditor = true;
  categories: PdfDocumentCategory[] = [];

  @ViewChild("editor") editor: any;
  @ViewChild("textArea") textArea!: ElementRef;

  schoolDocument: PdfDocumentType = new PdfDocumentType(1, "school document");
  studentDocument: PdfDocumentType = new PdfDocumentType(2, "student document");

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private router: Router,
    private toastService: PrimeToastService,
    public pdfService: PdfDocumentTemplateService
  ) { }

  ngOnInit() {
    this.templateForm = this.builder.group({
      name: ["", Validators.required],
      body: ["", Validators.required],
      language: [null, Validators.required],
      category: [null, Validators.required],
      documentTypeId: [2, Validators.required]
    });
    this.httpService.getLanguages().subscribe(res => {
      this.languages = res;
    });
    this.httpService.getPdfDocumentCategories().subscribe(res => {
      this.categories = res;
    });
  }

  sendForm(){
    if(this.templateForm.invalid){
      this.toastService.addError("Error", "Please complete all informations");
      return;
    }
  
    this.httpService.postPdfDocumentTemplate(
      new BookingReportTemplate(
        this.templateForm.value.body.trim(),
        this.templateForm.value.name.trim(),
        this.templateForm.value==1?this.schoolDocument: this.studentDocument,
        this.templateForm.value.language,
        this.templateForm.value.category
      )
    ).subscribe(() => {
      this.toastService.addSuccess("Success", "Template created");
      this.pdfService.activeItemId = PdfTemplateViewOption.BOOKING_RELATED;;
    }, error => this.toastService.addError("Error", error.message));
  }

  activateAdvanced(){
    this.advancedEditor = this.advancedEditor?false:true;
  }

  insertFieldValue(field: SelectItem){
    if(this.advancedEditor){
      this.insertStrToTextArea(field.value);
    } else {
      this.editor.instance.insertText(field.value);
    }
  }

  insertStrToTextArea(str: string){
    if(this.textArea.nativeElement.selectionStart || this.textArea.nativeElement.selectionStaart == '0'){
      let startPos = this.textArea.nativeElement.selectionStart;
      let endPos = this.textArea.nativeElement.selectionEnd;
      this.textArea.nativeElement.value = this.textArea.nativeElement.value.substring(0, startPos) + 
      str + this.textArea.nativeElement.value.substring(endPos, this.textArea.nativeElement.value.length);
    } else {
      this.textArea.nativeElement.value += str;
    }
  }

}
